import type { PatternProps } from "./shared";

export function HatchPattern({ color, salt }: PatternProps) {
	/** Render */
	return (
		<defs>
			<pattern
				id={`${salt}-hatchPattern`}
				patternUnits="userSpaceOnUse"
				width="14"
				height="14"
			>
				<path
					d="M-1.75,1.75 l3.5,-3.5 M0,14 l14,-14 M12.25,15.75 l3.5,-3.5"
					stroke={color}
					strokeWidth="1.75"
				/>
			</pattern>
		</defs>
	);
}
